export const contact = {
  id: "f506af04-6bc2-4547-9e44-c8d7e5aae3c2",
  phone: "0786529313",
  email: "nguyenlethanhquoc.181286@gmail.com",
  address: "60/12B Đ Lồ Ô, Phường Đông Hòa, Thành phố Hồ Chí Minh, Việt Nam",
  facebook_url: "https://www.facebook.com/daylaixe.quoc",
  zalo_url: "https://zalo.me/0786529313",
  tiktok_url: "https://www.tiktok.com/@quocdaylaixehochiminh",
  youtube_url: "",
  instagram_url: "",
};